import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem, ListItemText } from '@material-ui/core';
import { OutlinedCheckbox } from './styled';

const styledList =  {
    font: 'normal normal normal 16px SF Pro Text, Helvetica',
    textAlign: 'left',
    color: '#000000',
}

const FilterAgenda = ({ fixedList = [], value = [], onChange, list = [] }) => {
    const safeValue = value || [];
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        const handleScroll = (e) => {
            if (!open) return;

            const menuEl = document.querySelector('.menuAgenda .MuiPopover-paper, .menuAgenda .MuiMenu-paper');
            if (menuEl && menuEl.contains(e.target)) return;
            setOpen(false);
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [open]);

    const getCheckboxState = (options) => {
        const selected = options.every((opt) => safeValue.includes(opt));
        const indeterminate = options.some((opt) => safeValue.includes(opt)) && !selected;
        return { selected, indeterminate };
    };

    const trainingOptions = list.map((opt) => opt.description);
    const categoryOptions = fixedList.map((item) => item.description);
    const trainingState = getCheckboxState(trainingOptions);
    const categoryState = getCheckboxState(categoryOptions);

    const handleGroupToggle = (options, isSelected) => {
        let newValues = [...safeValue];

        if (isSelected) {
            newValues = newValues.filter((v) => !options.includes(v));
        } else {
            options.forEach((opt) => {
                if (!newValues.includes(opt)) newValues.push(opt);
            });
        }

        onChange({ target: { value: newValues.filter(Boolean) } });
    };

    const handleItemToggle = (itemValue) => {
        let newValues = [...safeValue];

        if (newValues.includes(itemValue)) {
            newValues = newValues.filter((v) => v !== itemValue);
        } else {
            newValues.push(itemValue);
        }

        onChange({ target: { value: newValues.filter(Boolean) } });
    };

    const renderGroup = ({
        title,
        items = [],
        options = [],
        state = {},
        onGroupToggle,
        onItemToggle,
        getLabel = (it) => it,
        getKey = (it, i) => `${title}-${i}`,
    }) => {
        const header = (
            <MenuItem
                key={`${title}-header`}
                disableRipple
                disableGutters
                selected={false}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onGroupToggle(options, state.selected);
                }}
                style={{
                    display: 'flex',
                    margin: '4px 0',
                    alignItems: 'center',
                    gap: 6,
                    backgroundColor: 'transparent',
                }}
            >
                <OutlinedCheckbox
                    checked={state.selected}
                    indeterminate={state.indeterminate}
                    style={{ opacity: 1, pointerEvents: 'none' }}
                />
                <ListItemText
                    primary={title}
                    primaryTypographyProps={{
                        style: styledList,
                    }}
                />
            </MenuItem>
        );

        const itemNodes = items.map((item, index) => {
            const label = getLabel(item);
            const key = getKey(item, index);
            return (
                <MenuItem
                    key={key}
                    value={label}
                    disableRipple
                    disableGutters
                    selected={false}
                    onClick={(e) => {
                        e.stopPropagation();
                        onItemToggle(label);
                    }}
                    style={{ paddingLeft: 32, backgroundColor: 'transparent', margin: '8px 0', gap: 6 }}
                >
                    <OutlinedCheckbox
                        variant="outlined"
                        checked={safeValue.includes(label)}
                        style={{ color: '#70A1A7', opacity: 1 }}
                    />
                    <ListItemText
                        primary={label}
                        primaryTypographyProps={{
                           style: styledList,
                        }}
                    />
                </MenuItem>
            );
        });

        return [header, ...itemNodes];
    };

    return (
       
            <FormControl variant="outlined" className="filterBox">
                <Select
                    multiple
                    open={open}
                    onOpen={handleOpen}
                    onClose={handleClose}
                    value={safeValue}
                    renderValue={(selected) => selected.filter((elem) => elem).join(',')}
                    className="menuAgenda"
                    MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                        transformOrigin: { vertical: 'top', horizontal: 'left' },
                        disablePortal: true,
                        PaperProps: {
                            style: {
                                width: 346,
                                maxHeight: 400,
                                padding: 12,
                                background: '#FFFFFF',
                                boxShadow: '0px 3px 6px #00000029',
                                border: '1px solid #C4C4C46E',
                                borderRadius: 4,
                            },
                        },
                    }}
                >
                    {renderGroup({
                        title: 'Treinamentos',
                        items: list,
                        options: trainingOptions,
                        state: trainingState,
                        onGroupToggle: handleGroupToggle,
                        onItemToggle: handleItemToggle,
                        getLabel: (it) => it.description,
                        getKey: (it) => it.idScheduleType,
                    })}

                    {fixedList.length > 0 &&
                        renderGroup({
                            title: 'Categoria de eventos',
                            items: fixedList,
                            options: categoryOptions,
                            state: categoryState,
                            onGroupToggle: handleGroupToggle,
                            onItemToggle: handleItemToggle,
                            getLabel: (it) => it.description,
                            getKey: (it, i) => `${it.description}-${i}`,
                        })}
                </Select>
            </FormControl>
    );
};

export default FilterAgenda;
